module.exports = __webpack_public_path__ + "img/barcode.d9a00a16.png";